/**
 * Sentry Initialization for Dashboard
 *
 * This module initializes Sentry error tracking for the CharityStack dashboard.
 * The dashboard is a secure, authenticated area where nonprofits manage their account.
 */

import { Sentry, getSentryConfig } from '@charitystack/shared';

export const initSentry = () => {
  const isDevelopment = import.meta.env.VITE_APP_ENVIRONMENT === 'development';
  const dsn = import.meta.env.VITE_APP_SENTRY_DSN;


  // Validate DSN exists (Sentry SDK will validate format)
  if (!dsn) {
    console.error('⚠️ VITE_APP_SENTRY_DSN not configured - Sentry error tracking disabled');
    return;
  }

  // Initialize Sentry with dashboard-specific configuration
  try {
    Sentry.init({
      dsn,
      ...getSentryConfig('dashboard', {
        browserTracingIntegration: Sentry.browserTracingIntegration,
        replayIntegration: Sentry.replayIntegration,
        consoleLoggingIntegration: Sentry.consoleLoggingIntegration,
      }),

      // Setting this option to true will send default PII data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
    });

    console.log('✅ Sentry initialized for dashboard');
  } catch (error) {
    console.error('⚠️ Sentry initialization failed for dashboard:', error);
    // App continues without error tracking - this is non-critical
  }
};
